interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  const start = Math.max(1, page - 2);
  const end = Math.min(totalPages, start + 4);
  for (let i = start; i <= end; i += 1) pages.push(i);

  const btnBase =
    'min-w-9 h-9 px-3 rounded-md text-sm font-medium flex items-center justify-center transition-colors cursor-pointer whitespace-nowrap';

  return (
    <div className="flex items-center justify-center flex-wrap gap-2">
      <button
        type="button"
        disabled={page === 1}
        onClick={() => onChange(page - 1)}
        className={`${btnBase} border border-background-300 text-foreground-700 hover:bg-background-100 disabled:opacity-40 disabled:cursor-not-allowed`}
      >
        <i className="ri-arrow-left-s-line"></i>
        上一页
      </button>

      {start > 1 && (
        <>
          <button type="button" onClick={() => onChange(1)} className={`${btnBase} border border-background-300 text-foreground-700 hover:bg-background-100`}>
            1
          </button>
          {start > 2 && <span className="px-1 text-foreground-500">…</span>}
        </>
      )}

      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          className={`${btnBase} ${
            p === page
              ? 'bg-primary-500 text-background-50'
              : 'border border-background-300 text-foreground-700 hover:bg-background-100'
          }`}
        >
          {p}
        </button>
      ))}

      {end < totalPages && (
        <>
          {end < totalPages - 1 && <span className="px-1 text-foreground-500">…</span>}
          <button type="button" onClick={() => onChange(totalPages)} className={`${btnBase} border border-background-300 text-foreground-700 hover:bg-background-100`}>
            {totalPages}
          </button>
        </>
      )}

      <button
        type="button"
        disabled={page === totalPages}
        onClick={() => onChange(page + 1)}
        className={`${btnBase} border border-background-300 text-foreground-700 hover:bg-background-100 disabled:opacity-40 disabled:cursor-not-allowed`}
      >
        下一页
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </div>
  );
}